import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paperInner: {
    margin: '1rem',
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },
  detailsItem: {
    fontWeight: 700,
  },
  container: {
    minWidth: '100%',
    margin: 0,
  },
}));

export { useStyles };
